import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerFetchPrePaidTxnListApiCallSuccess } from 'redux/actions';
import { TRIGGER_FETCH_PREPAID_TXN_LIST_API } from 'redux/actionTypes';
import { apiCall } from 'services';

function* triggerPrePaidFetchTxnListApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const PAGE_NUM = data['pageNum'];
	const PAGE_SIZE = data['pageSize'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url:
			API_CONSTANT.URL.PREPAID_TXN_LIST +
			API_CONSTANT.QUERY_PARAMS.PAGE_NUM +
			PAGE_NUM +
			API_CONSTANT.QUERY_PARAMS.PAGE_SIZE +
			PAGE_SIZE,
		method: 'GET',
		options: {
			defaultLoader: !stopLoader,
		},
		loaderDetails: {
			first_message: 'fetching your',
			start_index: 0,
			range: 9,
			second_message: 'transactions',
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		callback && callback(apiData);
		yield put(triggerFetchPrePaidTxnListApiCallSuccess(apiData));
	}
}

export default function* triggerPrePaidFetchTxnListApiCallSaga() {
	yield takeEvery(TRIGGER_FETCH_PREPAID_TXN_LIST_API, triggerPrePaidFetchTxnListApiCall);
}
